import { baseApiUrl, siteUrl } from '../../config/env';
import asyncStoreService from '../async-store.service';

export const getTokenApi = async (userName, password, isSso = false, additionalInfo) => {
  if (userName) {
    if (additionalInfo) {
      const groupKey = additionalInfo.split(',')[0];
      const companyKey = additionalInfo.split(',')[1];
      userName = userName + ',' + siteUrl + ',' + groupKey + ',' + companyKey;
    } else {
      userName = userName + ',' + siteUrl;
    }
  }
  const res = await fetch(`${baseApiUrl}/Token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: `grant_type=password&username=${encodeURIComponent(
      userName
    )}&password=${encodeURIComponent(password)}&siteKey=${encodeURIComponent(
      siteUrl
    )}&isSSo=${isSso}`,
  });
  return res.json();
};

export const userAuthenticateApiSSO = async (uuid, password) => {
  const param = {
    UserGuid: uuid,
    Username: uuid,
    Password: password,
    SiteUrl: siteUrl,
    IsSsoLogIn: true,
  };

  return await authenticate(param);
};

export const authenticate = async (param) => {
  const res = await fetch(`${baseApiUrl}/user/authenticate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });

  return res.json();
};

export const checkSSOUserGUID = async (param) => {
  const res = await fetch(`${baseApiUrl}/user/CheckSSOUserGUID`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });

  return res.json();
};

export const userAuthenticateApi = async (userName, password) => {
  const param = {
    Username: `${userName}`,
    Password: password,
    SiteUrl: siteUrl,
    IsSsoLogIn: false,
  };
  const res = await fetch(`${baseApiUrl}/user/authenticate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });

  if (res.status === 401 || res.status === 500) {
    const errorResponse = await res.json();
    return {
      error: true,
      message: errorResponse?.Message || 'Authentication failed.',
    };
  }

  return res.json();
};

export const ssoAuthenticateApi = async (userName, password) => {
  const param = { Username: `${userName}`, Password: password, SiteUrl: siteUrl };
  const res = await fetch(`${baseApiUrl}/user/Login_WithoutPassword`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });
  return res.json();
};

let gdsInfoCache = null;

export const fetchGdsInfo = async () => {
  if (gdsInfoCache) {
    return gdsInfoCache;
  }
  const accessToken = await asyncStoreService.getTokenData();
  const res = await fetch(`${baseApiUrl}/auth/GDSInfo`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken.access_token}`,
    },
  });
  const json = res.json();
  if (!res.ok) {
    throw json;
  }
  gdsInfoCache = json;
  return json;
};

export const validateBxAuth = async (param) => {
  const accessToken = await asyncStoreService.getTokenData();
  const res = await fetch(`${baseApiUrl}/auth/Validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken.access_token}`,
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });
  if (!res.ok) {
    throw new Error('Error');
  }
  return res.json();
};

export const validateAAdvantageNo = async (data) => {
  const accessToken = await asyncStoreService.getTokenData();
  const res = await fetch(`${baseApiUrl}/cart/ValidateAAdvantageNo`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken.access_token}`,
    },
    body: JSON.stringify({ aAdvantageNumbers: data }),
  });
  if (!res.ok) {
    throw new Error('Error');
  }
  return res.json();
};

export const forgotPasswordApi = async (id) => {
  const res = await fetch(`${baseApiUrl}/user/ForgotPassword/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
  });
  return res.json();
};

export const checkAnswerApi = async (id, userAnswer, questionId, checkAnswer) => {
  const param = { id, userAnswer, questionId, checkAnswer };
  const res = await fetch(`${baseApiUrl}/user/CheckAnswer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });
  return res.json();
};

export const getNextQuestionApi = async (id) => {
  const res = await fetch(`${baseApiUrl}/user/GetNextQuestion/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer null',
    },
  });
  return res.json();
};

export const getActivationApi = async (value) => {
  try {
    const response = await fetch(`${baseApiUrl}/user/GetActivationDetails?value=${value}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching activation details: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const activateUserApi = async (param) => {
  const res = await fetch(`${baseApiUrl}/user/Activate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });
  return res.json();
};
